var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileDel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_412_5742)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.364 2.36396C14.7782 1.77822 13.8284 1.77815 13.2426 2.36395L8.99995 6.60656L4.75731 2.36391C4.17157 1.77817 3.2218 1.7781 2.63598 2.36391C2.05017 2.94971 2.05023 3.89947 2.63597 4.48522L6.87861 8.72786L2.63594 12.9705C2.05012 13.5563 2.05018 14.506 2.63593 15.0918C3.22167 15.6775 4.17144 15.6776 4.75726 15.0918L8.99993 10.8492L13.2426 15.0918C13.8283 15.6776 14.7781 15.6776 15.3639 15.0918C15.9497 14.506 15.9497 13.5563 15.3639 12.9705L11.1213 8.72788L15.364 4.48527C15.9498 3.89947 15.9497 2.94971 15.364 2.36396Z",
    fill: "#F04400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDel);
export default __webpack_public_path__ + "static/media/fileDel.a00807aa5378a89ce461039dbc91fd4c.svg";
export { ForwardRef as ReactComponent };